import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Receipt } from "lucide-react";

/**
 * "Legg til kvittering" dialog. Presentation-only: parent owns the
 * `newReceipt` state and `onSave` handler so no behavior changes.
 */
export default function AddReceiptDialog({
  open,
  onOpenChange,
  newReceipt,
  setNewReceipt,
  store,
  onSave,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="receipt-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "'Cormorant Garamond', serif" }}>Legg til kvittering</DialogTitle>
          <DialogDescription>Registrer et betalt kjøp for denne uken</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-stone-700 block mb-1">Beløp (kr) *</label>
            <input
              type="number"
              step="0.01"
              value={newReceipt.amount}
              onChange={(e) => setNewReceipt({ ...newReceipt, amount: e.target.value })}
              placeholder="0.00"
              className="w-full rounded-md border border-stone-200 bg-white px-3 py-2 text-sm focus:border-navy-800 focus:ring-1 focus:ring-navy-800 outline-none"
              data-testid="receipt-amount-input"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-stone-700 block mb-1">Dato</label>
            <input
              type="date"
              value={newReceipt.date}
              onChange={(e) => setNewReceipt({ ...newReceipt, date: e.target.value })}
              className="w-full rounded-md border border-stone-200 bg-white px-3 py-2 text-sm focus:border-navy-800 focus:ring-1 focus:ring-navy-800 outline-none"
              data-testid="receipt-date-input"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-stone-700 block mb-1">Notat (valgfritt)</label>
            <input
              value={newReceipt.note}
              onChange={(e) => setNewReceipt({ ...newReceipt, note: e.target.value })}
              placeholder="F.eks. Ukens storhandel..."
              className="w-full rounded-md border border-stone-200 bg-white px-3 py-2 text-sm focus:border-navy-800 focus:ring-1 focus:ring-navy-800 outline-none"
              data-testid="receipt-note-input"
            />
          </div>
          <div className="text-xs text-stone-400">
            Butikk: <span className="font-medium text-stone-600">{store || "Ingen butikk valgt"}</span>
          </div>
          <button
            onClick={onSave}
            className="w-full inline-flex items-center justify-center rounded-md bg-navy-800 px-4 py-2.5 text-sm font-medium text-white hover:bg-navy-900 transition-colors gap-2"
            data-testid="save-receipt-btn"
          >
            <Receipt className="h-4 w-4" /> Lagre kvittering
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
